export default {
  noDescription: 'Geen beschrijving',
  start: 'Start',
  plannedStart: 'Geplande start van batch'
};
